
import React, { useState } from "react";
import Footer from "../Footer";
import "../../css/BangGiaQuayChup.css";

const packages = [
    {
        id: "silver",
        name: "SILVER",
        image: "https://raw.githubusercontent.com/VuongMinh01/MinMedia-anh/main/BangGia/images/1.png",
    },
    {
        id: "gold",
        name: "GOLD",
        image: "https://raw.githubusercontent.com/VuongMinh01/MinMedia-anh/main/BangGia/images/2.png",
    },
    {
        id: "platinum",
        name: "PLATINUM",
        image: "https://raw.githubusercontent.com/VuongMinh01/MinMedia-anh/main/BangGia/images/3.png",
    },
    {
        id: "diamond",
        name: "DIAMOND",
        image: "https://raw.githubusercontent.com/VuongMinh01/MinMedia-anh/main/BangGia/images/4.png",
    },
];

export default function BangGiaQuayChup() {
    const [selectedImage, setSelectedImage] = useState(null);

    return (
        <>
            <main className="quay-page">
                <section className="quay-prices">
                    <div className="quay-container">
                        <div className="quay-section-heading">
                            <div>
                                <span className="quay-eyebrow">
                                    MinMin Wedding - Phóng Sự Cưới
                                </span>
                                <h2>Các gói dịch vụ</h2>
                                <p>
                                    Lưu giữ những khoảnh khắc đáng nhớ
                                    trong ngày trọng đại của bạn.
                                </p>
                            </div>
                        </div>



                        <div className="package-image-grid">
                            {packages.map((item) => (
                                <article className="package-image-card" key={item.id}>
                                    <div className="package-image-heading" data-package={item.id}>
                                        <h3>{item.name}</h3>
                                    </div>

                                    <button
                                        type="button"
                                        className="package-image-button"
                                        onClick={() => setSelectedImage(item)}
                                        aria-label={`Xem ảnh gói ${item.name}`}
                                    >
                                        <img
                                            src={item.image}
                                            alt={`Bảng giá gói ${item.name}`}
                                            loading="lazy"
                                        />
                                        <span className="package-image-hint">
                                            Nhấn để xem ảnh lớn
                                        </span>
                                    </button>
                                </article>
                            ))}
                        </div>


                    </div>
                </section>
            </main>

            {selectedImage && (
                <div
                    className="image-lightbox"
                    onClick={() => setSelectedImage(null)}
                    role="presentation"
                >
                    <button
                        type="button"
                        className="image-lightbox-close"
                        onClick={() => setSelectedImage(null)}
                        aria-label="Đóng ảnh"
                    >
                        &times;
                    </button>

                    <div
                        className="image-lightbox-content"
                        onClick={(event) => event.stopPropagation()}
                    >
                        <h3>{selectedImage.name}</h3>
                        <img
                            src={selectedImage.image}
                            alt={`Bảng giá gói ${selectedImage.name} kích thước lớn`}
                        />
                        <p>Nhấn bên ngoài ảnh để đóng</p>
                    </div>
                </div>
            )}

            <Footer />
        </>
    );
}
